<template>
  <Addition v-if="isAddition">
    <template #field>{{ change.field.name }}</template>
    <p>
      {{ $t(`message.openStatusTypes.${change.new_value}`) }}
    </p>
  </Addition>
  <Removal v-else-if="isRemoval">
    <template #field>{{ change.field.name }}</template>
    <p class="old-value">
      {{ $t(`message.openStatusTypes.${change.old_value}`) }}
    </p>
  </Removal>
  <Change v-else-if="isChange">
    <template #field>{{ change.field.name }}</template>
    <template #old>
      <p>
        {{ $t(`message.openStatusTypes.${change.old_value}`) }}
      </p>
    </template>
    <template #new>
      <p class="new-value">
        {{ $t(`message.openStatusTypes.${change.new_value}`) }}
      </p>
    </template>
  </Change>
</template>

<script>
import { EXTERNAL_CHANGES_TYPE } from "@/enums/external-changes";

import Addition from "@/components/ExternalChanges/general/Addition.vue";
import Removal from "@/components/ExternalChanges/general/Removal.vue";
import Change from "@/components/ExternalChanges/general/Change.vue";

export default {
  name: "OpenStatusChange",
  props: {
    change: {
      type: Object,
      required: true
    }
  },
  components: { Addition, Removal, Change },

  computed: {
    isAddition() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.ADDITION &&
            this.change.new_value
        : false;
    },
    isRemoval() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.REMOVAL &&
            this.change.old_value
        : false;
    },
    isChange() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.CHANGE &&
            this.change.new_value &&
            this.change.old_value
        : false;
    }
  }
};
</script>

<style lang="scss" scoped>
.new-value {
  font-weight: bold;
}

.old-value {
  text-decoration: line-through;
}
</style>
